// @flow

import * as React from 'react';
import glamorous from 'glamorous';
import JackpotSlots from '../../games/jackpotSlots/src/index';

type Props = {
  getCurrentUser: () => void,
  onDestroy?: () => void,
  onPostSpin: () => void,
  parent: string,
  stopSpinning: () => void,
  winAmount: number,
};

const CanvasParent = glamorous.div(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  maxHeight: 550,
  flexGrow: 1,
  marginTop: theme.spacing.small,
  [theme.mediaQuery.tabletLandscapeAndBelow]: {
    marginLeft: -theme.spacing.small,
    marginRight: -theme.spacing.small,
  },
}));

class JackpotSlotsGame extends React.Component<Props> {
  props: Props;
  static defaultProps = {
    onDestroy: undefined,
  };
  game: Object;
  ref: React.Node;

  componentDidMount() {
    this.game = JackpotSlots.create(this.ref, this.getSendProps());
  }

  componentDidUpdate() {
    this.game.signals.componentDidUpdate.dispatch(this.getSendProps());
  }

  componentWillUnmount() {
    console.log('destroy jackpot slots game');
    const { onDestroy } = this.props;
    if (onDestroy) onDestroy();
    if (this.game) this.game.destroy();
  }

  handleSpinComplete = () => {
    const { winAmount, stopSpinning, getCurrentUser } = this.props;
    stopSpinning();
    if (winAmount) {
      // update the bonus balance
      getCurrentUser();
    } else {
      // handle lose
    }
  };

  handleFreeSpinTime = () => {
    const { getCurrentUser } = this.props;
    getCurrentUser();
  };

  getSendProps() {
    const { onPostSpin, getCurrentUser, ...restProps } = this.props;
    return {
      onSpin: onPostSpin,
      onSpinComplete: this.handleSpinComplete,
      onFreeSpinTime: this.handleFreeSpinTime,
      resolution: 1,
      ...restProps,
    };
  }

  render() {
    return <CanvasParent innerRef={ref => (this.ref = ref)} />;
  }
}

export default JackpotSlotsGame;
